import apiClient from "./apiClient";

/* ================= CLIENTES (ADMIN) ================= */

export function getClients(params = {}) {
  return apiClient.get("clients", { params });
}

export function createClient(client) {
  return apiClient.post("clients", client);
}

export function updateClient(id, client) {
  return apiClient.put(`clients/${id}`, client);
}

export function deleteClient(id) {
  return apiClient.delete(`clients/${id}`);
}

export function getClientMovements(id) {
  return apiClient.get(`clients/${id}/movements`);
}

export function createMovement(id, movement) {
  return apiClient.post(`clients/${id}/movements`, movement);
}

/* ================= MI CUENTA CORRIENTE (CLIENTE) ================= */

export function getMyStatement() {
  return apiClient.get("my-account/statement");
}

export function getMyMovements() {
  return apiClient.get("my-account/movements");
}

/* ================= AUTENTICACIÓN SOCIAL ================= */

export function loginWithGoogle(idToken) {
  return apiClient.post("auth/google", { idToken });
}

export function loginWithFacebook(accessToken) {
  return apiClient.post("auth/facebook", { accessToken });
}
